import {Component, OnInit} from "@angular/core";
import {Auth2Service} from "../../../../../services/auth2.service";
import {ApiService} from "../../../../../services/api.service";
import {UserService} from "../../../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {SearchService} from "../../../../search-nonprofits-donors/services/search.service";
import {SearchGrantsService} from "../../../../search-grants/services/search-grants.service";
import {SearchIDsCriteriaDto} from "../../../../../models/search-ids-criteria-dto";
import {LoggedInPageBaseComponent} from "../../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-saved-searches-nonprofit-create-edit',
  templateUrl: './saved-searches-nonprofit-create-edit.component.html',
  styleUrls: ['./saved-searches-nonprofit-create-edit.component.scss'],
  standalone: false
})
export class SavedSearchesNonprofitCreateEditComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Your Saved Searches', path: 'app/users/dashboard/saved-searches/all'},
    { label: 'Create / Edit Nonprofit Saved Search'}
  ];

  //DONOR_SEARCH default, but there is also GRANT_SEARCH and NONPROFIT_SEARCH
  searchTypeName = "NONPROFIT_SEARCH";

  currentSavedSearchDto: any = null;
  advancedFiltersButton: boolean = false;

  searchTypeNameMap: any = {};
  searchTypeNameLoadedFlag: boolean = false;
  affiliationCodeIdsLoadedFlag: boolean = false;
  deductabilityCodeIdsLoadedFlag: boolean = false;
  filingReqCodeIdsLoadedFlag: boolean = false;
  foundationCodeIdsLoadedFlag: boolean = false;
  nteeCodeIdsLoadedFlag: boolean = false;
  nteeParentCodeIdsLoadedFlag: boolean = false;
  organizationCodeIdsLoadedFlag: boolean = false;
  returnTypeCodeIdsLoadedFlag: boolean = false;
  totalAssetsLoadedFlag: boolean = false
  causesLoadedFlag: boolean = false;

  savedSearchLoadedFlag: boolean = false;

  username: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;
  readOnly: boolean = false;

  savedNonprofitSearchName: string = '';
  nonprofit_names: string[] = [];
  nonprofit_nameInput: string = '';
  nonprofit_namesWithout: string[] = [];
  nonprofit_nameWithoutInput: string = '';
  nonprofit_eins: string[] = [];
  nonprofit_einInput: string = '';
  includeTaxExemptRevoked: boolean = true;
  minYearsInBusiness: number = 0;
  nonprofit_states: string[] = [];
  nonprofit_stateInput: string = '';
  nonprofit_cities: string[] = [];//will only be one
  nonprofit_citiesInput: string = '';
  nonprofit_citiesWithout: string[] = [];//will only be one
  nonprofit_citiesWithoutInput: string = '';
  nonprofit_zipCodes: string[] = [];//will only be one
  nonprofit_zipCodeInput: string = '';
  nonprofit_counties: string[] = [];//will only be one
  nonprofit_countiesInput: string = '';
  nonprofit_countiesWithout: string[] = [];//will only be one
  nonprofit_countiesWithoutInput: string = '';
  nonprofit_affiliationCodeIds: number[] = [];
  nonprofit_deductabilityCodeIds: number[] = [];
  nonprofit_eoClassificationCodes: string[] = [];
  nonprofit_eoSubsectionCodes: string[] = [];
  nonprofit_filingReqCodeIds: number[] = [];
  nonprofit_pfFilingReqCodeIds: number[] = [];
  nonprofit_foundationCodeIds: number[] = [];
  nonprofit_nteeCodeIds: number[] = [];
  nonprofit_nteeParentCodeIds: number[] = [];
  nonprofit_organizationCodeIds: number[] = [];
  nonprofit_returnTypeCodeIds: number[] = [];
  nonprofit_totalAssetsRange: number[] = [];// will always be just one if selected but the end result is 2 (a min and a max)
  nonprofit_totalIncomeRange: number[] = [];
  nonprofit_causes: string[] = [];
  nonprofit_causeGivingInterestsList: string[] = [];
  nonprofit_causeGivingInterestsWithoutList: string[] = [];
  nonprofit_keyStaff: string[] = [];// will always be just one
  nonprofit_keyStaffInput: string = '';

  nonprofit_statesList: any[] = [];
  nonprofit_citiesCheckboxes: any[] = [];
  nonprofit_affiliationCodeCheckboxes: any[] = [];
  nonprofit_affiliationCodeButton: boolean = false;

  nonprofit_deductabilityCodeCheckboxes: any[] = [];
  nonprofit_deductabilityCodeButton: boolean = false;

  nonprofit_eoSubsectionClassificationCodeCheckboxes: any[] = [];
  nonprofit_eoSubsectionClassificationCodeButton: boolean = false;

  nonprofit_filingReqCodeCheckboxes: any[] = [];
  nonprofit_filingReqCodeButton: boolean = false;

  nonprofit_pfFilingReqCodeCheckboxes: any[] = [];
  nonprofit_pfFilingReqCodeButton: boolean = false;

  nonprofit_foundationCodeCheckboxes: any[] = [];
  nonprofit_foundationCodeButton: boolean = false;

  nonprofit_nteeCodeCheckboxes: any[] = [];
  nonprofit_nteeCodeButton: boolean = false;

  nonprofit_nteeParentCodeCheckboxes: any[] = [];
  nonprofit_nteeParentCodeButton: boolean = false;

  nonprofit_organizationCodeCheckboxes: any[] = [];
  nonprofit_organizationCodeButton: boolean = false;

  nonprofit_returnTypeCodeCheckboxes: any[] = [];
  nonprofit_returnTypeCodeButton: boolean = false;

  nonprofit_totalAssetsRadioButtons: any[] = [];
  nonprofit_totalAssetsButton: any = false;

  nonprofit_causesRadioButtons: any[] = [];
  nonprofit_causesButton: any = false;

  browserUrl: string = '';

  companyNameAscRadioButton: boolean = false;
  companyNameDescRadioButton: boolean = false;
  cityAscRadioButton: boolean = false;
  cityDescRadioButton: boolean = false;
  stateAscRadioButton: boolean = false;
  stateDescRadioButton: boolean = false;
  totalAssetsAscRadioButton: boolean = false;
  totalAssetsDescRadioButton: boolean = false;

  sortByCompanyNameAscId: number = 0;
  sortByCityAscId: number = 0;
  sortByStateAscId: number = 0;
  sortByTotalAssetsAscId: number = 0;

  companyNamesAutocomplete: any[] = [];
  citiesAutocomplete: any[] = [];

  causeDropdownList: any[] = [];
  causeGivingInterestsDropdownList: any[] = [];

  nonprofit_givingInterestsSetObj: any = {};
  nonprofit_givingInterestsWithoutSetObj: any = {};

  nonprofit_causeGivingInterestsSetObj: any = {};
  logicalOperatorAnd: boolean = false;
  logicalOperatorOr: boolean = true;

  //Needs pop up for SavedSearch Limit on creation
  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService : UserService,
              private searchService: SearchService, private searchGrantsService: SearchGrantsService,
              private routerChild: Router, private route: ActivatedRoute, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Create or Edit Nonprofit Saved Search");
  }

  populateNonprofitsCities(): void {
    // @ts-ignore
    let nonprofitCitiesCacheExpTimeStr: string = localStorage.getItem('nonprofitCitiesCacheExpTime');
    if (!nonprofitCitiesCacheExpTimeStr) {
      //expire the cached search
      localStorage.removeItem('nonprofitCitiesCache');
    } else {
      let lastSearchNonprofitExpTime: number = parseInt(nonprofitCitiesCacheExpTimeStr);
      let now = Date.now();
      if (now >= lastSearchNonprofitExpTime) {
        //expire the cached search
        localStorage.removeItem('nonprofitCitiesCache');
      }
    }
    const nonprofitCitiesCacheJsonString = localStorage.getItem('nonprofitCitiesCache');
    if (!nonprofitCitiesCacheJsonString) {
      this.searchService.getNonprofitsCities(this.username).subscribe((result: any) => {
        if (result && result.body) {
          let i: number = 0;
          while (i < result.body.size) {
            this.citiesAutocomplete.push(result.body.citiesStates[i]);
            i = i + 1;
          }
          let expirationTimestamp: number = Date.now() + 1000*3600*8;
          localStorage.setItem('nonprofitCitiesCacheExpTime', expirationTimestamp.toString());
          localStorage.setItem('nonprofitCitiesCache', JSON.stringify(this.citiesAutocomplete));
        }
      }, (error: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Search Nonprofits Error',
          detail: 'Failed to pull Nonprofit cities.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      })
    } else {
      this.citiesAutocomplete = JSON.parse(nonprofitCitiesCacheJsonString);
    }
  }

  populateNonprofitsCompanyNames(): void {
    this.searchService.getNonprofitsCompanyNames(this.username).subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.companyNamesAutocomplete.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Search Nonprofits Error',
        detail: 'Failed to pull Nonprofit company names.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }

  ngOnInit() {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    this.browserUrl = window.location.href;
    this.readOnly = this.apiService.calculateReadOnly(this.browserUrl, this.impersonatedEmail, this.consultantRoleName);
    if (this.browserUrl.includes('view')) {
      this.titleService.setTitle("Scalanthropy View Nonprofit Saved Search");
      this.breadCrumbs[4] = { label: 'View Nonprofit Saved Search'};
    }
    this.searchTypeNameLoadedFlag = false;
    //this.affiliationCodeIdsLoadedFlag = false;
    //this.deductabilityCodeIdsLoadedFlag = false;
    this.filingReqCodeIdsLoadedFlag = false;
    this.foundationCodeIdsLoadedFlag = false;
    this.nteeCodeIdsLoadedFlag = false;
    this.nteeParentCodeIdsLoadedFlag = false;
    this.organizationCodeIdsLoadedFlag = false;
    this.returnTypeCodeIdsLoadedFlag = false;
    this.totalAssetsLoadedFlag = false
    this.causesLoadedFlag = false;

    this.savedSearchLoadedFlag = false;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })

    this.loadSearchTypeNameMap();
    if(this.browserUrl.includes('view')) {
      const currentSavedSearchId = this.route.snapshot.paramMap.get('savedSearchId');
      // @ts-ignore
      this.userService.getSavedSearch(currentSavedSearchId, this.username, this.impersonatedEmail).subscribe(
        (result: any) => {
          if (result && result.body) {
            this.currentSavedSearchDto = result.body;
            //Distribute the saved search parameters to the radioboxes,checkboxes, and textboxes
            this.loadSavedNonprofitSearchParams();
            this.savedSearchLoadedFlag = true;
          }
          return;
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Saved Search API Failure',
            detail: 'Failed to download the savedSearchId: ' + currentSavedSearchId,
            severity: 'error'
          });
          this.showErrorMessagesToUser();
          return;
        }
      );
    } else {
      this.populateUSAStates();
      this.populateNonprofitsCities();
      this.populateNonprofitsCompanyNames();
      //this.populateAffiliationCodeCheckboxes(); Not currently used
      //this.populateDeductabilityCodeCheckboxes(); Not currently used
      this.populateFoundationCodeCheckboxes();
      this.populateFilingReqCodeCheckboxes();
      this.populateNteeCodeCheckboxes();
      this.populateNteeParentCodeCheckboxes();
      this.populateOrganizationCodeCheckboxes();
      this.populateReturnTypeCodeCheckboxes();
      this.populateTotalAssetsRangeRadioButtons();
      this.populateCausesDropdown();
      this.populateCauseGivingInterestsDropdown();
      //retries
      let retries_limit = 4;
      let count = 0;
      while (count < retries_limit) {
        setTimeout(() => {
          if (this.savedSearchLoadedFlag) {
            return;
          }
          if (this.searchTypeNameLoadedFlag && this.foundationCodeIdsLoadedFlag && this.filingReqCodeIdsLoadedFlag &&
            this.nteeCodeIdsLoadedFlag && this.nteeParentCodeIdsLoadedFlag && this.organizationCodeIdsLoadedFlag &&
            this.returnTypeCodeIdsLoadedFlag && this.totalAssetsLoadedFlag && this.causesLoadedFlag) {
            this.browserUrl = window.location.href;
            if (this.browserUrl.includes('edit') || this.browserUrl.includes('view')) {
              //extract the id from the browser url
              const currentSavedSearchId = this.route.snapshot.paramMap.get('savedSearchId');
              //load the saved search from the database
              // @ts-ignore
              this.userService.getSavedSearch(currentSavedSearchId, this.username).subscribe(
                (result: any) => {
                  if (result && result.body) {
                    this.currentSavedSearchDto = result.body;
                    //Distribute the saved search parameters to the radioboxes,checkboxes, and textboxes
                    this.loadSavedNonprofitSearchParams();
                    this.savedSearchLoadedFlag = true;
                  }
                }, (err: HttpErrorResponse) => {
                  this.redirectToLogin(err);
                  this.pageErrorMessages.push({
                    field: 'Grant Saved Search API Error',
                    detail: 'Failed to download the savedSearchId: ' + currentSavedSearchId,
                    severity: 'error'
                  });
                  this.showPageErrorMessagesToUser();
                }
              );
            }
          }
        }, 8000);
        count = count + 1;
      }
    }

  }

  loadSavedNonprofitSearchParams(): void {
    if (this.currentSavedSearchDto.savedSearchName) {
      this.savedNonprofitSearchName = this.currentSavedSearchDto.savedSearchName;
    }
    if (this.currentSavedSearchDto.savedSearchJson) {
      let nonprofitSearchJson: any = JSON.parse(this.currentSavedSearchDto.savedSearchJson);
      if (nonprofitSearchJson['names'] && nonprofitSearchJson['names'].length > 0) {
        this.nonprofit_nameInput = nonprofitSearchJson['names'].join(',');
        console.log('this.nonprofit_nameInput: ' + this.nonprofit_nameInput);
      }
      /*
      if (nonprofitSearchJson['namesWithout'] && nonprofitSearchJson['namesWithout'].length > 0) {
        this.nonprofit_nameWithoutInput = nonprofitSearchJson['namesWithout'][0];
      }*/
      if (nonprofitSearchJson['eins'] && nonprofitSearchJson['eins'].length > 0) {
        this.nonprofit_einInput = nonprofitSearchJson['eins'][0];
      }
      if (nonprofitSearchJson['states'] && nonprofitSearchJson['states'].length > 0) {
        //this.donor_stateInput = donorSearchJson['states'][0];
        if (!this.readOnly) {
          const usaStatesEl = document.getElementById('usa-dropdown-list-id');
          // @ts-ignore
          usaStatesEl.value = nonprofitSearchJson['states'][0];
        } else {
          const usaStatesEl = document.getElementById('usa-state-text-id');
          // @ts-ignore
          usaStatesEl.value = nonprofitSearchJson['states'][0];
        }

      }
      if (nonprofitSearchJson['cities'] && nonprofitSearchJson['cities'].length > 0) {
        this.nonprofit_citiesInput = nonprofitSearchJson['cities'].join(',');
      }
      /*
      if (nonprofitSearchJson['citiesWithout'] && nonprofitSearchJson['citiesWithout'].length > 0) {
        this.nonprofit_citiesWithoutInput = nonprofitSearchJson['citiesWithout'][0];
      }*/
      if (nonprofitSearchJson['zipCodes'] && nonprofitSearchJson['zipCodes'].length > 0) {
        this.nonprofit_zipCodeInput = nonprofitSearchJson['zipCodes'][0];
      }
      /*
      if (nonprofitSearchJson['counties'] && nonprofitSearchJson['counties'].length > 0) {
        this.nonprofit_countiesInput = nonprofitSearchJson['counties'][0];
      }
      if (nonprofitSearchJson['countiesWithout'] && nonprofitSearchJson['countiesWithout'].length > 0) {
        this.nonprofit_countiesWithoutInput = nonprofitSearchJson['countiesWithout'][0];
      }*/
      /*
      if (nonprofitSearchJson['keyStaff'] && nonprofitSearchJson['keyStaff'].length > 0) {
        this.nonprofit_keyStaffInput = nonprofitSearchJson['keyStaff'][0];
      }*/
      /*
      if (nonprofitSearchJson['filingReqCodeIds'] && nonprofitSearchJson['filingReqCodeIds'].length > 0) {
        for (const filingReqCodeId of nonprofitSearchJson['filingReqCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.nonprofit_filingReqCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.nonprofit_filingReqCodeCheckboxes[i].filingReqCodeId === filingReqCodeId) {
              this.nonprofit_filingReqCodeCheckboxes[i].checked = true;
            }
            i = i + 1;
          }
        }
      }*/
      /*
      if (nonprofitSearchJson['foundationCodeIds'] && nonprofitSearchJson['foundationCodeIds'].length > 0) {
        for (const foundationCodeId of nonprofitSearchJson['foundationCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.nonprofit_foundationCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.nonprofit_foundationCodeCheckboxes[i].foundationCodeId === foundationCodeId) {
              this.nonprofit_foundationCodeCheckboxes[i].checked = true;
            }
            i = i + 1;
          }
        }
      }*/

      if (nonprofitSearchJson['nteeCodeIds'] && nonprofitSearchJson['nteeCodeIds'].length > 0) {
        for (const nteeCodeId of nonprofitSearchJson['nteeCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.nonprofit_nteeCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.nonprofit_nteeCodeCheckboxes[i].nteeCodeId === nteeCodeId) {
              this.nonprofit_nteeCodeCheckboxes[i].checked = true;
              this.nonprofit_nteeCodeButton = true
            }
            i = i + 1;
          }
        }
        this.advancedFiltersButton = true;
      }

      if (nonprofitSearchJson['nteeParentCodeIds'] && nonprofitSearchJson['nteeParentCodeIds'].length > 0) {
        for (const nteeParentCodeId of nonprofitSearchJson['nteeParentCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.nonprofit_nteeParentCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.nonprofit_nteeParentCodeCheckboxes[i].nteeParentCodeId === nteeParentCodeId) {
              this.nonprofit_nteeParentCodeCheckboxes[i].checked = true;
              this.nonprofit_nteeParentCodeButton = true;
            }
            i = i + 1;
          }
        }
        this.advancedFiltersButton = true;
      }

      if (nonprofitSearchJson['organizationCodeIds'] && nonprofitSearchJson['organizationCodeIds'].length > 0) {
        for (const organizationCodeId of nonprofitSearchJson['organizationCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.nonprofit_organizationCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.nonprofit_organizationCodeCheckboxes[i].organizationCodeId === organizationCodeId) {
              this.nonprofit_organizationCodeCheckboxes[i].checked = true;
              this.nonprofit_organizationCodeButton = true;
            }
            i = i + 1;
          }
        }
        this.advancedFiltersButton = true;
      }

      this.nonprofit_causeGivingInterestsList = [];
      if (nonprofitSearchJson['causeGivingInterests'] && nonprofitSearchJson['causeGivingInterests'].length > 0) {
        for (const causeGivingInterest of nonprofitSearchJson['causeGivingInterests']) {
          this.nonprofit_causeGivingInterestsList.push(causeGivingInterest);
        }
      }

      this.nonprofit_causeGivingInterestsWithoutList = [];
      /*
      if (nonprofitSearchJson['causeGivingInterestsWithout'] && nonprofitSearchJson['causeGivingInterestsWithout'].length > 0) {
        for (const causeGivingInterest of nonprofitSearchJson['causeGivingInterestsWithout']) {
          this.nonprofit_causeGivingInterestsWithoutList.push(causeGivingInterest);
        }
      }*/
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      if (nonprofitSearchJson['sortByCompanyNameAsc']) {
        if (nonprofitSearchJson['sortByCompanyNameAsc'] == 1) {
          this.companyNameAscRadioButton = true;
        } else if (nonprofitSearchJson['sortByCompanyNameAsc'] == 2) {
          this.companyNameDescRadioButton = true;
        }
      }

      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      if (nonprofitSearchJson['sortByCityAsc']) {
        if (nonprofitSearchJson['sortByCityAsc'] == 1) {
          this.cityAscRadioButton = true;
        } else if (nonprofitSearchJson['sortByCityAsc'] == 2) {
          this.cityDescRadioButton = true;
        }
      }

      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      if (nonprofitSearchJson['sortByStateAsc']) {
        if (nonprofitSearchJson['sortByStateAsc'] == 1) {
          this.stateAscRadioButton = true;
        } else if (nonprofitSearchJson['sortByStateAsc'] == 2) {
          this.stateDescRadioButton = true;
        }
      }

      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
      if (nonprofitSearchJson['sortByTotalAssetsAsc']) {
        if (nonprofitSearchJson['sortByTotalAssetsAsc'] == 1) {
          this.totalAssetsAscRadioButton = true;
        } else if (nonprofitSearchJson['sortByTotalAssetsAsc'] == 2) {
          this.totalAssetsDescRadioButton = true;
        }
      }
      /*
      if (nonprofitSearchJson['returnTypeCodeIds'] && nonprofitSearchJson['returnTypeCodeIds'].length > 0) {
        for (const returnTypeCodeId of nonprofitSearchJson['returnTypeCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.nonprofit_returnTypeCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.nonprofit_returnTypeCodeCheckboxes[i].returnTypeCodeId === returnTypeCodeId) {
              this.nonprofit_returnTypeCodeCheckboxes[i].checked = true;
            }
            i = i + 1;
          }
        }
      }*/

      /*
      if (nonprofitSearchJson['totalAssetsRange'] && nonprofitSearchJson['totalAssetsRange'].length > 0) {
        for (const assetRangeObj of this.nonprofit_totalAssetsRadioButtons) {
          let i: number = 0;
          if (assetRangeObj.minTotalAssets === nonprofitSearchJson['totalAssetsRange'][0]
            && assetRangeObj.maxTotalAssets === nonprofitSearchJson['totalAssetsRange'][1]) {
            assetRangeObj.checked = true;
            break;
          }
        }
      }*/

      /*
      if (nonprofitSearchJson['causes'] && nonprofitSearchJson['causes'].length > 0) {
        for (const cause of nonprofitSearchJson['causes']) {
          let i: number = 0;
          let affCodeLength: number = this.nonprofit_causesRadioButtons.length;
          while (i < affCodeLength) {
            if (this.nonprofit_causesRadioButtons[i].causeName === cause) {
              this.nonprofit_causesRadioButtons[i].checked = true;
              break;
            }
            i = i + 1;
          }
        }
      }*/
    }

  }

  loadSearchTypeNameMap(): void {
    this.searchService.getSearchTypeNamesDropdown(this.username)
      .subscribe((result: any) => {
        if (result && result.body) {
          for (const searchTypeNameTemp of result.body){
            this.searchTypeNameMap[searchTypeNameTemp.searchTypeName] = searchTypeNameTemp.searchTypeId;
          }
          this.searchTypeNameLoadedFlag = true;
        }
        return;
    }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Grant Saved Search API Error',
          detail: 'Failed to pull the Search Type Names...',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        this.searchTypeNameLoadedFlag = false;
        return;
      });
    this.searchTypeNameLoadedFlag = false;
    return;
  }

  toggleAdvancedFilters(): any {
    this.advancedFiltersButton = !this.advancedFiltersButton;
  }

  resetFilters(): void {
    const nonprofitNameInputEl = document.getElementById('nonprofit-name-with-text-id');
    // @ts-ignore
    nonprofitNameInputEl.value = '';
    /*
    const nonprofitNameWithoutInputEl = document.getElementById('nonprofit-name-without-text-id');
    // @ts-ignore
    nonprofitNameWithoutInputEl.value = '';
     */
    const nonprofitEinInputEl = document.getElementById('nonprofit-ein-text-id');
    // @ts-ignore
    nonprofitEinInputEl.value = '';
    const nonprofitCityInputEl = document.getElementById('nonprofit-cities-text-id');
    // @ts-ignore
    nonprofitCityInputEl.value = '';
    /*
    const nonprofitCityWithoutInputEl = document.getElementById('nonprofit-city-without-text-id');
    // @ts-ignore
    nonprofitCityWithoutInputEl.value = '';
     */
    const usaStateDropdownEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    usaStateDropdownEl.value = '';
    const nonprofitZipCodeInputEl = document.getElementById('nonprofit-zip-code-text-id');
    // @ts-ignore
    nonprofitZipCodeInputEl.value = '';
    /*
    const nonprofitCountyInputEl = document.getElementById('nonprofit-county-text-id');
    // @ts-ignore
    nonprofitCountyInputEl.value = '';
    const nonprofitCountyWithoutInputEl = document.getElementById('nonprofit-county-without-text-id');
    // @ts-ignore
    nonprofitCountyWithoutInputEl.value = '';
     */
    /*
    const nonprofitKeyStaffInputEl = document.getElementById('nonprofit-key-staff-text-id');
    // @ts-ignore
    nonprofitKeyStaffInputEl.value = '';
     */
    this.nonprofit_nameInput = '';
    this.nonprofit_einInput = '';
    this.nonprofit_citiesInput = '';
    this.nonprofit_zipCodeInput = '';
    this.nonprofit_keyStaffInput = '';

    this.minYearsInBusiness = 0;
    /*
    const minYearsInBusinessEl = document.getElementById('min-years-in-business-text-id');
    // @ts-ignore
    minYearsInBusinessEl.value = '';
    */
    this.includeTaxExemptRevoked = true;

    for(const nonprofit_affiliationCodeCheckbox of this.nonprofit_affiliationCodeCheckboxes) {
      nonprofit_affiliationCodeCheckbox.checked = false;
    }

    for(const nonprofit_deductabilityCodeCheckbox of this.nonprofit_deductabilityCodeCheckboxes) {
      nonprofit_deductabilityCodeCheckbox.checked = false;
    }

    for(const nonprofit_filingReqCodeCheckbox of this.nonprofit_filingReqCodeCheckboxes) {
      nonprofit_filingReqCodeCheckbox.checked = false;
    }

    for(const nonprofit_foundationCodeCheckbox of this.nonprofit_foundationCodeCheckboxes) {
      nonprofit_foundationCodeCheckbox.checked = false;
    }

    for(const nonprofit_nteeCodeCheckbox of this.nonprofit_nteeCodeCheckboxes) {
      nonprofit_nteeCodeCheckbox.checked = false;
    }

    for(const nonprofit_nteeParentCodeCheckbox of this.nonprofit_nteeParentCodeCheckboxes) {
      nonprofit_nteeParentCodeCheckbox.checked = false;
    }

    for(const nonprofit_organizationCodeCheckbox of this.nonprofit_organizationCodeCheckboxes) {
      nonprofit_organizationCodeCheckbox.checked = false;
    }

    for(const nonprofit_totalAssetsRadioButton of this.nonprofit_totalAssetsRadioButtons) {
      nonprofit_totalAssetsRadioButton.checked = false;
    }

    for(const nonprofit_causesRadioButton of this.nonprofit_causesRadioButtons) {
      nonprofit_causesRadioButton.checked = false;
    }

    this.nonprofit_causeGivingInterestsList = [];
    this.nonprofit_causeGivingInterestsWithoutList = [];

    const causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    causeCategorySel.value = '';

    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    causeGivingInterestEl.value = '';

    this.companyNameAscRadioButton = false;
    this.companyNameDescRadioButton = false;
    this.cityAscRadioButton = false;
    this.cityDescRadioButton = false;
    this.stateAscRadioButton = false;
    this.stateDescRadioButton = false;
    this.totalAssetsAscRadioButton = false;
    this.totalAssetsDescRadioButton = false;

    this.sortByCompanyNameAscId = 0;
    this.sortByCityAscId = 0;
    this.sortByStateAscId = 0;
    this.sortByTotalAssetsAscId = 0;
  }

  loadFilters(): boolean {
    this.populateUSAStates();
    this.populateAffiliationCodeCheckboxes();
    this.populateDeductabilityCodeCheckboxes();
    this.populateFoundationCodeCheckboxes();
    this.populateFilingReqCodeCheckboxes();
    this.populateNteeCodeCheckboxes();
    this.populateNteeParentCodeCheckboxes();
    this.populateOrganizationCodeCheckboxes();
    this.populateReturnTypeCodeCheckboxes();
    this.populateTotalAssetsRangeRadioButtons();
    return true;
  }

  populateUSAStates(): void {
    this.nonprofit_statesList = [];
    this.searchService.getUSAStatesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        //this.statesList = result.body;
        let i: number = 0;
        while (i < result.body.length) {
          this.nonprofit_statesList.push(result.body[i]);
          i = i + 1;
        }
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Error',
        detail: 'Failed to pull the USA States...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      return;
    })
    return;
  }

  toggleNonprofitAffiliationCodesFilter(): void {
    this.nonprofit_affiliationCodeButton = !this.nonprofit_affiliationCodeButton;
  }

  addValToNonprofitAffiliationCodes(idValue:number): void {
    const nonprofitAffiliationCodeEl = document.getElementById('flexCheckCheckedNonprofitAffiliationCode-' + idValue);
    // @ts-ignore
    this.nonprofit_affiliationCodeCheckboxes[idValue]['checked'] = nonprofitAffiliationCodeEl.checked;
  }

  populateAffiliationCodeCheckboxes(): void {
    this.searchService.getAffiliationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nonprofit_affiliationCodeCheckboxes = result.body;
        this.affiliationCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Error',
        detail: 'Failed to pull the Affiliation Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.affiliationCodeIdsLoadedFlag = false;
      return;
    })
    this.affiliationCodeIdsLoadedFlag = false;
    return;
  }

  toggleNonprofitDeductabilityCodesFilter(): void {
    this.nonprofit_deductabilityCodeButton = !this.nonprofit_deductabilityCodeButton;
  }

  addValToNonprofitDeductabilityCodes(idValue:number): void {
    const nonprofit_deductabilityCodeEl = document.getElementById('flexCheckCheckedNonprofitDeductabilityCode-' + idValue);
    // @ts-ignore
    this.nonprofit_deductabilityCodeCheckboxes[idValue]['checked'] = nonprofitDeductabilityCodeEl.checked;
  }

  populateDeductabilityCodeCheckboxes(): void {
    this.searchService.getDeductibilityCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nonprofit_deductabilityCodeCheckboxes = result.body;
        this.deductabilityCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Error',
        detail: 'Failed to pull the Deductability Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.deductabilityCodeIdsLoadedFlag = false;
      return;
    });
    this.deductabilityCodeIdsLoadedFlag = false;
    return;
  }

  toggleNonprofitFilingReqCodesFilter(): void {
    this.nonprofit_filingReqCodeButton = !this.nonprofit_filingReqCodeButton;
  }

  addValToNonprofitFilingReqCodes(idValue:number): void {
    const nonprofitFilingReqCodeEl = document.getElementById('flexCheckCheckedNonprofitFilingReqCode-' + idValue);
    // @ts-ignore
    const nonprofitFilingReqCodeChecked = nonprofitFilingReqCodeEl.checked;
    this.nonprofit_filingReqCodeCheckboxes[idValue]['checked'] = nonprofitFilingReqCodeChecked;
  }

  populateFilingReqCodeCheckboxes(): void {
    this.searchService.getFilingReqCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nonprofit_filingReqCodeCheckboxes = [];
        let i: number = 0;
        while (i < result.body.length) {
          this.nonprofit_filingReqCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        this.filingReqCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Error',
        detail: 'Failed to pull the Filing Req Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.filingReqCodeIdsLoadedFlag = false;
      return;
    });
    this.filingReqCodeIdsLoadedFlag = false;
    return;
  }

  toggleNonprofitFoundationCodesFilter(): void {
    this.nonprofit_foundationCodeButton = !this.nonprofit_foundationCodeButton;
  }

  addValToNonprofitFoundationCodes(idValue:number): void {
    const nonprofitFoundationCodeEl = document.getElementById('flexCheckCheckedNonprofitFoundationCode-' + idValue);
    // @ts-ignore
    this.nonprofit_foundationCodeCheckboxes[idValue]['checked'] = nonprofitFoundationCodeEl.checked;
  }

  populateFoundationCodeCheckboxes(): void {
    this.searchService.getFoundationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nonprofit_foundationCodeCheckboxes = [];
        let i: number = 0;
        while (i < result.body.length) {
          this.nonprofit_foundationCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        this.foundationCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Error',
        detail: 'Failed to pull the Foundation Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.foundationCodeIdsLoadedFlag = false;
      return;
    });
    this.foundationCodeIdsLoadedFlag = false;
    return;
  }

  toggleRevokeLogicalExpression(): void {
    this.includeTaxExemptRevoked = !this.includeTaxExemptRevoked;
  }
  toggleNonprofitNteeCodesFilter(): void {
    this.nonprofit_nteeCodeButton = !this.nonprofit_nteeCodeButton;
  }

  addValToNonprofitNteeCodes(idValue:number): void {
    const nteeCodeEl = document.getElementById('flexCheckCheckedNonprofitNteeCode-' + idValue);
    // @ts-ignore
    this.nonprofit_nteeCodeCheckboxes[idValue]['checked'] = nteeCodeEl.checked;
  }

  populateNteeCodeCheckboxes(): void {
    this.searchService.getNteeCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nonprofit_nteeCodeCheckboxes = [];
        let i : number = 0;
        while (i < result.body.length) {
          this.nonprofit_nteeCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        this.nteeCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Error',
        detail: 'Failed to pull the Ntee Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.nteeCodeIdsLoadedFlag = false;
      return;
    });
    this.nteeCodeIdsLoadedFlag = false;
    return;
  }

  toggleNonprofitNteeParentCodesFilter(): void {
    this.nonprofit_nteeParentCodeButton = !this.nonprofit_nteeParentCodeButton;
  }
  addValToNonprofitNteeParentCodes(idValue:number): void {
    const nteeParentCodeEl = document.getElementById('flexCheckCheckedNonprofitNteeParentCode-' + idValue);
    // @ts-ignore
    this.nonprofit_nteeParentCodeCheckboxes[idValue]['checked'] = nteeParentCodeEl.checked;
  }

  populateNteeParentCodeCheckboxes(): void {
    this.searchService.getNteeParentCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nonprofit_nteeParentCodeCheckboxes = [];
        let i : number = 0;
        while (i < result.body.length) {
          this.nonprofit_nteeParentCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        this.nteeParentCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Error',
        detail: 'Failed to pull the Ntee Parent Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.nteeParentCodeIdsLoadedFlag = false;
      return;
    });
    this.nteeParentCodeIdsLoadedFlag = false;
    return;
  }

  toggleNonprofitOrganizationCodesFilter(): void {
    this.nonprofit_organizationCodeButton = !this.nonprofit_organizationCodeButton;
  }
  addValToNonprofitOrganizationCodes(idValue:number): void {
    const organizationCodeEl = document.getElementById('flexCheckCheckedNonprofitOrganizationCode-' + idValue);
    // @ts-ignore
    this.nonprofit_organizationCodeCheckboxes[idValue]['checked'] = organizationCodeEl.checked;
  }

  populateOrganizationCodeCheckboxes(): void {
    this.searchService.getOrganizationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nonprofit_organizationCodeCheckboxes = [];
        let i: number = 0;
        while (i < result.body.length) {
          this.nonprofit_organizationCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        this.organizationCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Error',
        detail: 'Failed to pull the Organization Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.organizationCodeIdsLoadedFlag = false;
      return;
    });
    this.organizationCodeIdsLoadedFlag = false;
    return;
  }

  toggleNonprofitReturnTypeCodesFilter(): void {
    this.nonprofit_returnTypeCodeButton = !this.nonprofit_returnTypeCodeButton;
  }

  addValToNonprofitReturnTypeCodes(idValue:number): void {
    const returnTypeCodeEl = document.getElementById('flexCheckCheckedNonprofitReturnTypeCode-' + idValue);
    // @ts-ignore
    this.nonprofit_returnTypeCodeCheckboxes[idValue]['checked'] = returnTypeCodeEl.checked;
  }

  populateReturnTypeCodeCheckboxes(): void {
    this.searchService.getReturnTypeCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nonprofit_returnTypeCodeCheckboxes = [];
        let i: number = 0;
        while (i < result.body.length) {
          this.nonprofit_returnTypeCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }

        this.returnTypeCodeIdsLoadedFlag = true;
        for ( const returnTypeCodeCheckboxTemp1 of this.nonprofit_returnTypeCodeCheckboxes) {
          if (returnTypeCodeCheckboxTemp1['returnTypeCodeName'] !== '990PF') {
            returnTypeCodeCheckboxTemp1['checked'] = true;
          } else {
            returnTypeCodeCheckboxTemp1['checked'] = false;
          }
        }
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Error',
        detail: 'Failed to pull the Return Type Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.returnTypeCodeIdsLoadedFlag = false;
      return;
    });
    this.returnTypeCodeIdsLoadedFlag = false;
    return;
  }

  toggleNonprofitTotalAssetsFilter(): any {
    this.nonprofit_totalAssetsButton = !this.nonprofit_totalAssetsButton;
  }

  trackNonprofitTotalAssetsRange(idValue:number): void {
    //Clear Radio Buttons
    for (const radioButton of this.nonprofit_totalAssetsRadioButtons) {
      radioButton.checked = false;
    }
    const totalAssetsRangeEl = document.getElementById('flexRadioNonprofitTotalAssets-' + idValue);
    // @ts-ignore
    this.nonprofit_totalAssetsRadioButtons[idValue]['checked'] = totalAssetsRangeEl.checked;
  }

  populateTotalAssetsRangeRadioButtons(): void {
    this.searchService.getTotalAssetsRangeDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nonprofit_totalAssetsRadioButtons = [];
        let i: number = 0;
        while (i < result.body.length) {
          this.nonprofit_totalAssetsRadioButtons.push(result.body[i]);
          i = i + 1;
        }
        this.totalAssetsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Grant Saved Search API Error',
        detail: 'Failed to pull the Total Assets Filters...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.totalAssetsLoadedFlag = false;
      return;
    });
    this.totalAssetsLoadedFlag = false;
    return;
  }

  toggleNonprofitCausesFilter(): any {
    this.nonprofit_causesButton = !this.nonprofit_causesButton;
  }

  trackNonprofitCauses(idValue:number): void {
    //Clear Radio Buttons
    for (const radioButton of this.nonprofit_causesRadioButtons) {
      radioButton.checked = false;
    }
    const causesEl = document.getElementById('flexRadioNonprofitCauses-' + idValue);
    // @ts-ignore
    const causesChecked = causesEl.checked;
    this.nonprofit_causesRadioButtons[idValue]['checked'] = causesChecked;
  }

  onCancel() {
    this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/all');
  }

  executeSearch(browserUrl: string, savedSearchName: string, filter: string, username: string,
                saveAndApplyFlag: boolean, impersonatedEmail: string | undefined): void {
    if (browserUrl.includes('create')) {
      const savedSearchDto: any = {
        savedSearchId: -1,
        userId: -1,
        savedSearchName: savedSearchName,
        searchTypeDto: {
          searchTypeId: this.searchTypeNameMap[this.searchTypeName],
          searchTypeName: this.searchTypeName
        },
        savedSearchJson: filter,
        createdTS: new Date(),
        updatedTS: new Date()
      }
      this.userService.addNewSavedSearch(savedSearchDto, username, impersonatedEmail).subscribe(
        (result: any) => {
          if (result && result.body) {
            this.currentSavedSearchDto = result.body;
            if (saveAndApplyFlag) {
              let expirationTimestamp: number = Date.now() + 1000*3600*2;
              localStorage.setItem('lastSearchNonprofitExpTime', expirationTimestamp.toString());
              localStorage.setItem('lastSearchNonprofit', this.currentSavedSearchDto.savedSearchJson);
              this.routerChild.navigateByUrl('app/search/nonprofits');
            } else {
              this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/all');
            }
          }
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          if (err.error && err.error.limitReached == "Y"
            && err.error.currentAmount == err.error.limitAmount) {
            this.pageErrorMessages.push({
              field: 'Saved Searches Limit Reached',
              detail: 'Woah, woah! You have reached your limit of ' + err.error.limitAmount +' saved searches. Consider deleting some saved searches.',
              severity: 'error'
            });
          } else {
            this.pageErrorMessages.push({
              field: 'Nonprofit Saved Search API Failure',
              detail: 'Failed to create the saved search name: ' + savedSearchDto.savedSearchName,
              severity: 'error'
            });
          }
          this.showPageErrorMessagesToUser();
        }
      );

    } else if (browserUrl.includes('edit')) {
      const savedSearchDto: any = {
        savedSearchId: this.currentSavedSearchDto.savedSearchId,
        userId: this.currentSavedSearchDto.userId,
        savedSearchName: savedSearchName,
        searchTypeDto: {
          searchTypeId: this.searchTypeNameMap[this.searchTypeName],
          searchTypeName: this.searchTypeName
        },
        savedSearchJson: filter,
        createdTS: this.currentSavedSearchDto.createdTS,
        updatedTS: this.currentSavedSearchDto.updatedTS
      }
      this.userService.editSavedSearch(savedSearchDto, username, impersonatedEmail).subscribe(
        (result: any) => {
          if (result && result.body) {
            this.currentSavedSearchDto = result.body;
            if (saveAndApplyFlag) {
              let expirationTimestamp: number = Date.now() + 1000*3600*2;
              localStorage.setItem('lastSearchNonprofitExpTime', expirationTimestamp.toString());
              localStorage.setItem('lastSearchNonprofit', this.currentSavedSearchDto.savedSearchJson);
              this.routerChild.navigateByUrl('app/search/nonprofits');
            } else {
              this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/all');
            }
          }
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Nonprofit Saved Search API Failure',
            detail: 'Failed to update the saved search name: ' + savedSearchDto.savedSearchName,
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        }
      );
    } else {
      this.pageErrorMessages.push({
        field: 'Nonprofit Saved Search URL Failure',
        detail: 'URL Logic Error...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    }
  }

  private submitNonprofitSearch(saveAndApplyFlag: boolean): boolean {
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    let nonEmptyFilterFlag : boolean = false;
    this.savedNonprofitSearchName = '';
    const savedNonprofitSearchNameEl = document.getElementById('nonprofit-search-filter-name-text-id');
    // @ts-ignore
    const savedNonprofitSearchName = savedNonprofitSearchNameEl.value;
    if (savedNonprofitSearchName) {
      this.savedNonprofitSearchName = savedNonprofitSearchName;
      nonEmptyFilterFlag = true;
    } else {
      this.pageErrorMessages.push({
        field: 'Nonprofit Search Name Error',
        detail: 'The Nonprofit Search Name is required and must not exceed 50 characters.',
        severity: 'error'
      });
    }

    this.nonprofit_names = [];
    const nonprofitNamesEl = document.getElementById('nonprofit-name-with-text-id');
    // @ts-ignore
    const nonprofitNamesSelected = nonprofitNamesEl.value;
    if (nonprofitNamesSelected) {
      let cleanNonprofitNames: string =  this.apiService.trimLeadingTrailingSpaces(nonprofitNamesSelected);
      if (cleanNonprofitNames.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Nonprofit Names characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let nonprofitNamesFinal: string[] = cleanNonprofitNames.split(",");
      if (nonprofitNamesFinal.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Nonprofit Names limit exceeded. You are limited to 10 names.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < nonprofitNamesFinal.length; i = i + 1) {
        this.nonprofit_names.push(nonprofitNamesFinal[i]);
      }
      nonEmptyFilterFlag = true;
    }

    this.nonprofit_namesWithout = [];
    /*
    const nameWithoutEl = document.getElementById('nonprofit-name-without-text-id');
    // @ts-ignore
    const nameWithoutSelected = nameWithoutEl.value;
    console.log('nameWithoutSelected: ' + JSON.stringify(nameWithoutSelected));
    if (nameWithoutSelected) {
      this.nonprofit_namesWithout.push(nameWithoutSelected);
      nonEmptyFilterFlag = true;
    }*/

    this.nonprofit_eins = [];
    const einsEl = document.getElementById('nonprofit-ein-text-id');
    // @ts-ignore
    const einsSelected = einsEl.value;
    if (einsSelected) {
      let cleanEins: string =  this.apiService.trimLeadingTrailingSpaces(einsSelected);
      if (cleanEins.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Eins characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let cleanEinsFinal: string[] = cleanEins.split(",");
      if (cleanEinsFinal.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Eins limit exceeded. You are limited to 10 eins.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < cleanEinsFinal.length; i = i + 1) {
        this.nonprofit_eins.push(cleanEinsFinal[i]);
      }
      nonEmptyFilterFlag = true;
    }

    this.nonprofit_states = [];
    const usaStatesEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    const usaStatesSelected = usaStatesEl.value;
    if (usaStatesSelected) {
      this.nonprofit_states.push(usaStatesSelected);
      nonEmptyFilterFlag = true;
    }

    this.nonprofit_cities = [];
    const citiesEl = document.getElementById('nonprofit-cities-text-id');
    // @ts-ignore
    const citiesSelected = citiesEl.value;
    if (citiesSelected) {
      let cleanCities: string =  this.apiService.trimLeadingTrailingSpaces(citiesSelected);
      if (cleanCities.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Cities characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let citiesFinal: string[] = cleanCities.split(",");
      if (citiesFinal.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included cities limit exceeded. You are limited to 10 cities.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < citiesFinal.length; i = i + 1) {
        let finalCity = this.apiService.trimLeadingTrailingSpaces(citiesFinal[i])
        if (finalCity && !finalCity.startsWith(':')) {
          this.nonprofit_cities.push(finalCity);
        }
      }
      nonEmptyFilterFlag = true;
    }

    this.nonprofit_citiesWithout = [];
    /*
    const citiesWithoutEl = document.getElementById('nonprofit-cities-without-text-id');
    // @ts-ignore
    const citiesWithoutSelected = citiesWithoutEl.value;
    if (citiesWithoutSelected) {
      let cleanCitiesWithout: string =  this.apiService.trimLeadingTrailingSpaces(citiesWithoutSelected);
      if (cleanCitiesWithout.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded Cities characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let citiesWithoutFinal: string[] = cleanCitiesWithout.split(",");
      if (citiesWithoutFinal.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded cities limit exceeded. You are limited to 10 cities.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < citiesWithoutFinal.length; i = i + 1) {
        this.nonprofit_cities.push(citiesWithoutFinal[i]);
      }
      nonEmptyFilterFlag = true;
    }*/

    this.nonprofit_zipCodes = [];
    const zipCodesEl = document.getElementById('nonprofit-zip-code-text-id');
    // @ts-ignore
    const zipCodesSelected = zipCodesEl.value;
    if (zipCodesSelected) {
      let cleanZipCode: string = this.apiService.trimLeadingTrailingSpaces(zipCodesSelected);
      if (cleanZipCode.length > 20) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Ein characters limit exceeded. You are limited to 20 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      this.nonprofit_zipCodes.push(cleanZipCode);
      nonEmptyFilterFlag = true;
    }
    this.minYearsInBusiness = 0;
    /*
    const minYearsInBusinessEl = document.getElementById('min-years-in-business-text-id');
    if (minYearsInBusinessEl) {
      if (this.minYearsInBusiness > 0) {
        // @ts-ignore
        this.minYearsInBusiness = parseInt(minYearsInBusinessEl.value);
        nonEmptyFilterFlag = true;
      }
    }*/
    this.includeTaxExemptRevoked = true;
    const includeTaxExemptRevokedEl = document.getElementById('flexRadioIncludeRevocationList');
    if (includeTaxExemptRevokedEl) {
      // @ts-ignore
      this.includeTaxExemptRevoked = includeTaxExemptRevokedEl.checked;
      nonEmptyFilterFlag = true;
    }

    this.nonprofit_counties = [];
    /*
    const countiesEl = document.getElementById('nonprofit-counties-text-id');
    // @ts-ignore
    const countiesSelected = countiesEl.value;
    console.log('countiesSelected: ' + JSON.stringify(countiesSelected));
    if (countiesSelected) {
      this.nonprofit_counties.push(countiesSelected);
      nonEmptyFilterFlag = true;
    }*/

    this.nonprofit_countiesWithout = [];
    /*
    const countiesWithoutEl = document.getElementById('nonprofit-counties-without-text-id');
    // @ts-ignore
    const countiesWithoutSelected = countiesWithoutEl.value;
    console.log('countiesWithoutSelected: ' + JSON.stringify(countiesWithoutSelected));
    if (countiesWithoutSelected) {
      this.nonprofit_countiesWithout.push(countiesWithoutSelected);
      nonEmptyFilterFlag = true;
    }*/

    this.nonprofit_affiliationCodeIds = [];
    /*
    for (const affiliationCodeCheckboxTemp of this.nonprofit_affiliationCodeCheckboxes) {
      if (affiliationCodeCheckboxTemp.checked === true) {
        this.nonprofit_affiliationCodeIds.push(affiliationCodeCheckboxTemp.affiliationCodeId);
        nonEmptyFilterFlag = true;
      }
    }*/

    this.nonprofit_deductabilityCodeIds = [];
    /*
    for (const deductabilityCodeCheckboxTemp of this.nonprofit_deductabilityCodeCheckboxes) {
      if (deductabilityCodeCheckboxTemp.checked === true) {
        this.nonprofit_deductabilityCodeIds.push(deductabilityCodeCheckboxTemp.deductabilityCodeId);
        nonEmptyFilterFlag = true;
      }
    }*/

    this.nonprofit_eoClassificationCodes = [];
    this.nonprofit_eoSubsectionCodes = [];

    this.nonprofit_filingReqCodeIds = [];
    /*
    for (const filingReqCodeCheckboxTemp of this.nonprofit_filingReqCodeCheckboxes) {
      if (filingReqCodeCheckboxTemp.checked === true) {
        this.nonprofit_filingReqCodeIds.push(filingReqCodeCheckboxTemp.filingReqCodeId);
        nonEmptyFilterFlag = true;
      }
    }*/

    this.nonprofit_foundationCodeIds = [];
    /*
    for (const foundationCodeCheckboxTemp of this.nonprofit_foundationCodeCheckboxes) {
      if (foundationCodeCheckboxTemp.checked === true) {
        this.nonprofit_foundationCodeIds.push(foundationCodeCheckboxTemp.foundationCodeId);
        nonEmptyFilterFlag = true;
      }
    }*/

    this.nonprofit_nteeCodeIds = [];

    for (const nteeCodeCheckboxTemp of this.nonprofit_nteeCodeCheckboxes) {
      if (nteeCodeCheckboxTemp.checked === true) {
        this.nonprofit_nteeCodeIds.push(nteeCodeCheckboxTemp.nteeCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.nonprofit_nteeParentCodeIds = [];

    for (const nteeParentCodeCheckboxTemp of this.nonprofit_nteeParentCodeCheckboxes) {
      if (nteeParentCodeCheckboxTemp.checked === true) {
        this.nonprofit_nteeParentCodeIds.push(nteeParentCodeCheckboxTemp.nteeParentCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.nonprofit_organizationCodeIds = [];

    for (const organizationCodeCheckboxTemp of this.nonprofit_organizationCodeCheckboxes) {
      if (organizationCodeCheckboxTemp.checked === true) {
        this.nonprofit_organizationCodeIds.push(organizationCodeCheckboxTemp.organizationCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.nonprofit_returnTypeCodeIds = [];
    for (const returnTypeCodeCheckboxTemp of this.nonprofit_returnTypeCodeCheckboxes) {
      if (returnTypeCodeCheckboxTemp.checked === true) {
        this.nonprofit_returnTypeCodeIds.push(returnTypeCodeCheckboxTemp.returnTypeCodeId);
        //nonEmptyFilterFlag = true;
      }
    }

    //Time Varying Parameters
    //Total Assets Range
    this.nonprofit_totalAssetsRange = [];
    /*
    for (const totalAssetsRadioButtonTemp of this.nonprofit_totalAssetsRadioButtons) {
      if (totalAssetsRadioButtonTemp.checked === true) {
        this.nonprofit_totalAssetsRange.push(totalAssetsRadioButtonTemp.minTotalAssets);
        this.nonprofit_totalAssetsRange.push(totalAssetsRadioButtonTemp.maxTotalAssets);
        nonEmptyFilterFlag = true;
      }
    }*/

    this.nonprofit_causes = [];
    /*
    for (const causesRadioButtonTemp of this.nonprofit_causesRadioButtons) {
      if (causesRadioButtonTemp.checked === true) {
        this.nonprofit_causes.push(causesRadioButtonTemp.causeName);
        nonEmptyFilterFlag = true;
      }
    }
    console.log('causes: ' + JSON.stringify(this.nonprofit_causes));
    */
    //Key Employees
    this.nonprofit_keyStaff = [];
    /*
    const keyStaffEl = document.getElementById('nonprofit-key-staff-text-id');
    // @ts-ignore
    const keyStaffSelected = keyStaffEl.value;
    console.log('keyStaffSelected: ' + JSON.stringify(keyStaffSelected));
    if (keyStaffSelected) {
      this.nonprofit_keyStaff.push(keyStaffSelected);
      nonEmptyFilterFlag = true;
    }*/

    const browserUrl: string = window.location.href;

    if (this.nonprofit_names.length == 0 && this.nonprofit_eins.length == 0 && this.nonprofit_states.length == 0 && this.nonprofit_cities.length == 0 &&
      this.nonprofit_zipCodes.length == 0 && this.nonprofit_nteeCodeIds.length == 0 &&
      this.nonprofit_nteeParentCodeIds.length == 0 && this.nonprofit_organizationCodeIds.length == 0) {
      // Empty search query
      nonEmptyFilterFlag = false;
    }
    /*
    if (this.nonprofit_names.length == 0 && this.nonprofit_eins.length == 0 && this.nonprofit_states.length == 0 && this.nonprofit_cities.length == 0 &&
      this.nonprofit_zipCodes.length == 0 && this.nonprofit_affiliationCodeIds.length == 0 && this.nonprofit_deductabilityCodeIds.length == 0 &&
      this.nonprofit_eoClassificationCodes.length == 0 && this.nonprofit_eoSubsectionCodes.length == 0 && this.nonprofit_filingReqCodeIds.length == 0 &&
      this.nonprofit_pfFilingReqCodeIds.length == 0 && this.nonprofit_foundationCodeIds.length == 0 && this.nonprofit_nteeCodeIds.length == 0 &&
      this.nonprofit_nteeParentCodeIds.length == 0 && this.nonprofit_organizationCodeIds.length == 0 && this.nonprofit_totalAssetsRange.length == 0 &&
      this.nonprofit_causes.length == 0 && this.nonprofit_keyStaff.length == 0) {
      // Empty search query
      nonEmptyFilterFlag = false;
    }*/
    this.sortByCompanyNameAscId = 0;
    if (this.companyNameAscRadioButton) {
      this.sortByCompanyNameAscId = 1;
    } else if (this.companyNameDescRadioButton) {
      this.sortByCompanyNameAscId = 2;
    }

    this.sortByCityAscId = 0;
    if (this.cityAscRadioButton) {
      this.sortByCityAscId = 1;
    } else if (this.cityDescRadioButton) {
      this.sortByCityAscId = 2;
    }

    this.sortByStateAscId = 0;
    if (this.stateAscRadioButton) {
      this.sortByStateAscId = 1;
    } else if (this.stateDescRadioButton) {
      this.sortByStateAscId = 2;
    }

    this.sortByTotalAssetsAscId = 0;
    if (this.totalAssetsAscRadioButton) {
      this.sortByTotalAssetsAscId = 1;
    } else if (this.totalAssetsDescRadioButton) {
      this.sortByTotalAssetsAscId = 2;
    }

    if (!nonEmptyFilterFlag) {
      this.pageErrorMessages.push({
        field: 'Filter Error',
        detail: 'Please submit a non-empty filter.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      return false;
    }

    const filter: SearchIDsCriteriaDto = {
      'names': this.nonprofit_names,
      'namesWithout': this.nonprofit_namesWithout,
      'eins': this.nonprofit_eins,
      'includeTaxExemptRevoked': this.includeTaxExemptRevoked,
      'minYearsInBusiness': this.minYearsInBusiness,
      'states': this.nonprofit_states,
      'cities': this.nonprofit_cities,
      'citiesWithout': this.nonprofit_citiesWithout,
      'zipCodes': this.nonprofit_zipCodes,
      'donatedGrantsCities': [],
      'donatedGrantsStates': [],
      'taxYear': 0,
      'counties': this.nonprofit_counties,
      'countiesWithout': this.nonprofit_countiesWithout,
      'affiliationCodeIds': this.nonprofit_affiliationCodeIds,
      'deductibilityCodeIds': this.nonprofit_deductabilityCodeIds,
      'eoClassificationCodes': this.nonprofit_eoClassificationCodes,
      'eoSubsectionCodes': this.nonprofit_eoSubsectionCodes,
      'filingReqCodeIds': this.nonprofit_filingReqCodeIds,
      'pfFilingReqCodeIds': this.nonprofit_pfFilingReqCodeIds,
      'foundationCodeIds': this.nonprofit_foundationCodeIds,
      'nteeCodeIds': this.nonprofit_nteeCodeIds,
      'nteeParentCodeIds': this.nonprofit_nteeParentCodeIds,
      'organizationCodeIds': this.nonprofit_organizationCodeIds,
      'returnTypeCodeIds': this.nonprofit_returnTypeCodeIds,
      'totalAssetsRange': this.nonprofit_totalAssetsRange,
      'totalIncomeRange': this.nonprofit_totalIncomeRange,
      'causes': this.nonprofit_causes,
      'causeGivingInterests': this.nonprofit_causeGivingInterestsList,
      'causeGivingInterestsWithout': this.nonprofit_causeGivingInterestsWithoutList,
      'keyStaff': this.nonprofit_keyStaff,
      'sortByCompanyNameAsc': this.sortByCompanyNameAscId,
      'sortByCityAsc': this.sortByCityAscId,
      'sortByStateAsc': this.sortByStateAscId,
      'sortByTotalAssetsAsc': this.sortByTotalAssetsAscId
    }

    //Submit to API
    // @ts-ignore
    this.executeSearch(browserUrl, this.savedNonprofitSearchName, JSON.stringify(filter), this.username,
      saveAndApplyFlag, this.impersonatedEmail);
    return true;
  }

  onSubmit(saveAndApplyFlag: boolean) {
    this.submitNonprofitSearch(saveAndApplyFlag);
  }

  openSearchTypeFilters(evt:any, searchTypeInput: string): void {
    this.searchTypeName = searchTypeInput;

    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      // @ts-ignore
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    // @ts-ignore
    document.getElementById(searchTypeInput).style.display = "block";
  }

  toggleCompanyNameAscButton(): void {
    this.companyNameAscRadioButton = !this.companyNameAscRadioButton;

    if (this.companyNameAscRadioButton && this.companyNameDescRadioButton) {
      this.companyNameAscRadioButton = true;
      this.companyNameDescRadioButton = false;
    }
  }

  toggleCompanyNameDescButton(): void {
    this.companyNameDescRadioButton = !this.companyNameDescRadioButton;
    if (this.companyNameAscRadioButton && this.companyNameDescRadioButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = true;
    }
  }

  toggleCityAscButton(): void {
    this.cityAscRadioButton = !this.cityAscRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = true;
      this.cityDescRadioButton = false;
    }
  }

  toggleCityDescButton(): void {
    this.cityDescRadioButton = !this.cityDescRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = true;
    }
  }

  toggleStateAscButton(): void {
    this.stateAscRadioButton = !this.stateAscRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = true;
      this.stateDescRadioButton = false;
    }
  }

  toggleStateDescButton(): void {
    this.stateDescRadioButton = !this.stateDescRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = true;
    }
  }

  toggleTotalAssetsAscButton(): void {
    this.totalAssetsAscRadioButton = !this.totalAssetsAscRadioButton;
    if (this.totalAssetsAscRadioButton && this.totalAssetsDescRadioButton) {
      this.totalAssetsAscRadioButton = true;
      this.totalAssetsDescRadioButton = false;
    }
  }

  toggleTotalAssetsDescButton(): void {
    this.totalAssetsDescRadioButton = !this.totalAssetsDescRadioButton;
    if (this.totalAssetsAscRadioButton && this.totalAssetsDescRadioButton) {
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = true;
    }
  }

  populateCausesDropdown(): void {
    this.searchService.getCausesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.causeDropdownList = result.body
        this.causesLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Cause Categories...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.causesLoadedFlag = false;
      return;
    });
    this.causesLoadedFlag = false;
    return;
  }

  updateCauseGivingInterestsDropdown(): boolean {
    var causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    let causeCategorySelVal = causeCategorySel.value;
    if (causeCategorySel) {
      if (this.nonprofit_causeGivingInterestsSetObj[causeCategorySelVal]) {
        this.causeGivingInterestsDropdownList = this.nonprofit_causeGivingInterestsSetObj[causeCategorySelVal];
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsDropdownList.concat(
          [{givingInterestDisplayName: 'All Other Cause Category Giving Interests', givingInterestName: 'ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' }], this.nonprofit_causeGivingInterestsSetObj['ALL'])
      } else {
        this.causeGivingInterestsDropdownList = this.nonprofit_causeGivingInterestsSetObj["ALL"];
      }
    }
    return true;
  }

  populateCauseGivingInterestsDropdown(): void {
    this.searchService.getAllGivingInterestsDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nonprofit_causeGivingInterestsSetObj = result.body;
        this.causeGivingInterestsDropdownList = this.nonprofit_causeGivingInterestsSetObj["ALL"];
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Cause Giving Interests...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  trackLogicalExpression(logicalOperator: string): void {
    if (logicalOperator == 'AND') {
      this.logicalOperatorAnd = true;
      this.logicalOperatorOr = false;
    } else if (logicalOperator == 'OR') {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    } else {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    }
  }

  recalculateListOfGivingInterests2(causingGivingInterest: string): void {
    if (this.nonprofit_causeGivingInterestsList.length > 0) {
      if (this.logicalOperatorAnd && !this.logicalOperatorOr) {
        this.nonprofit_causeGivingInterestsList.push("AND");
      } else if (!this.logicalOperatorAnd && this.logicalOperatorOr) {
        this.nonprofit_causeGivingInterestsList.push("OR");
      } else {
        this.nonprofit_causeGivingInterestsList.push("OR");
      }
    }
    this.nonprofit_causeGivingInterestsList.push(causingGivingInterest);
  }

  recalculateListOfGivingInterestsWithout2(causingGivingInterest: string): void {
    this.nonprofit_causeGivingInterestsWithoutList.push(causingGivingInterest);
  }

  addCauseGivingInterestFilter2(addFlag: boolean): void {
    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    const causeGivingInterestSelected = causeGivingInterestEl.value;
    if (causeGivingInterestSelected) {
      if ('ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' == causeGivingInterestSelected) {
        return;
      }
      if (addFlag) {
        this.recalculateListOfGivingInterests2(causeGivingInterestSelected);
      } else {
        this.recalculateListOfGivingInterestsWithout2(causeGivingInterestSelected);
      }
    }
  }

  onDeleteGivingInterest(row: string): void {
    const index = this.nonprofit_causeGivingInterestsList.indexOf(row);
    const size = this.nonprofit_causeGivingInterestsList.length;
    const causeGivingInterestsListTemp: string[] = []
    if (size == 1) {
      this.nonprofit_causeGivingInterestsList = [];
      return;
    }
    if (index == (size - 1) ) {
      let excludedSize: number = size - 2;
      let i = 0;
      while (i < excludedSize) {
        causeGivingInterestsListTemp.push(this.nonprofit_causeGivingInterestsList[i]);
        i = i + 1;
      }
      this.nonprofit_causeGivingInterestsList = causeGivingInterestsListTemp;
      return;
    }
    let i = 0;
    while (i < size) {
      if (index == 0 && i == 0 && size > 1) {
        //skip elements 0 and 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.nonprofit_causeGivingInterestsList[i]);
      } else if (index == i && size > 1) {
        //skip elements i and i + 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.nonprofit_causeGivingInterestsList[i]);
      } else {
        causeGivingInterestsListTemp.push(this.nonprofit_causeGivingInterestsList[i]);
      }
      i = i + 1;
    }
    this.nonprofit_causeGivingInterestsList = causeGivingInterestsListTemp;
  }

  onDeleteGivingInterestWithout(row: string): void {
    const index = this.nonprofit_causeGivingInterestsWithoutList.indexOf(row);
    const size = this.nonprofit_causeGivingInterestsWithoutList.length;
    const causeGivingInterestsWithoutListTemp: string[] = [];
    let i = 0;
    while (i < size) {
      if (i != index) {
        causeGivingInterestsWithoutListTemp.push(this.nonprofit_causeGivingInterestsWithoutList[i]);
      }
      i = i + 1;
    }
    this.nonprofit_causeGivingInterestsWithoutList = causeGivingInterestsWithoutListTemp;
  }


  protected readonly event = event;
}
